<template>
  <div
    v-if="visible"
    class="modal-backdrop"
    @click.self="$emit('cancel')"
  >
    <div class="modal">
      <h3>Elegir color para el evento</h3>

      <!-- Picker manual -->
      <div class="color-input-section">
        <label>Color personalizado:</label>
        <input
          type="color"
          :value="selectedColor"
          @input="$emit('update:selectedColor', $event.target.value)"
        >
      </div>

      <!-- Colores por defecto -->
      <div
        v-if="event"
        class="default-colors-section"
      >
        <label>Color por defecto del formato:</label>
        <div class="default-colors">
          <button
            class="color-button"
            :class="{ active: selectedColor === defaultColor }"
            :style="{ backgroundColor: defaultColor }"
            @click="$emit('update:selectedColor', defaultColor)"
            :title="getFormatLabel(event.format)"
          >
            {{ getFormatLabel(event.format) }}
          </button>
        </div>
      </div>

      <!-- Acciones -->
      <div class="modal-actions">
        <button
          v-if="event"
          class="default-btn"
          @click="$emit('reset-default')"
        >
          Por defecto
        </button>
        <button
          class="ok"
          @click="$emit('save')"
        >
          Guardar
        </button>
        <button
          class="cancel"
          @click="$emit('cancel')"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
export default {
  name: 'ColorPickerModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object,
      default: null,
    },
    selectedColor: {
      type: String,
      default: '#ffffff',
    },
    defaultColor: {
      type: String,
      default: '#ffffff',
    },
  },
  emits: [
    'save',
    'cancel',
    'reset-default',
    'update:selectedColor',
  ],
  methods: {
    getFormatLabel(format) {
      const labels = {
        entero: 'Entero',
        harinado: 'Harinado',
        multiparticle: 'Multipartícula',
        pelet_3: 'Pelet 3',
        pelet_6: 'Pelet 6',
        pelet_8: 'Pelet 8',
        pelet_12: 'Pelet 12',
      };

      return labels[format] || 'Otro';
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  min-width: 300px;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  text-align: center;
}

.modal h3 {
  margin-top: 0;
  color: #2c3e50;
  margin-bottom: 20px;
}

.color-input-section {
  margin-bottom: 20px;
}

.color-input-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
}

.color-input-section input[type="color"] {
  width: 60px;
  height: 40px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.default-colors-section {
  margin-bottom: 20px;
}

.default-colors-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
}

.default-colors {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.color-button {
  padding: 8px 12px;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  color: #fff;
  font-size: 12px;
  transition: all 0.2s ease;
}

.color-button:hover {
  transform: scale(1.05);
  border-color: #fff;
}

.color-button.active {
  border-color: #2c3e50;
  transform: scale(1.1);
}

.modal-actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.modal-actions button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s ease;
}

.modal-actions .ok {
  background: #0B8043;
  color: #fff;
}

.modal-actions .ok:hover {
  background: #0a6b37;
}

.modal-actions .cancel {
  background: #e74c3c;
  color: #fff;
}

.modal-actions .cancel:hover {
  background: #c0392b;
}

.modal-actions .default-btn {
  background: #3498db;
  color: #fff;
}

.modal-actions .default-btn:hover {
  background: #2980b9;
}
</style>
